import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_PL: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Zdatność',
  components_header_media_1: 'Dla mężczyzn',
  components_header_media_2: 'Dla kobiet',
  components_header_media_multi_content_2: 'Joga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trenuj mądrzej, czuj się lepiej.',
  hero_button_text: 'Zacznij teraz',
  components_ressources_subheader_text: 'Przewodniki i porady',
  components_ressources_span_text: 'Łączy w sobie praktyczne aspekty jogi, kontrolowaną precyzję pilatesu i dynamiczne wyzwania treningu siłowego, wspierając wszechstronny i zdrowy styl życia.',
  components_ressources_card_1_title: 'Porady dotyczące jogi',
  components_ressources_card_1_text: 'Krótki przewodnik dotyczący lepszej równowagi, oddychania i płynności.',
  components_ressources_card_2_title: 'Porady Pilatesa',
  components_ressources_card_2_text: 'Proste wskazówki, jak wzmocnić mięśnie brzucha i poprawić kontrolę.',
  components_notes_and_google_title_1: 'Zbuduj siłę',
  components_notes_and_google_title_2: 'Joga Spokój',
  components_notes_and_google_title_3: 'Ćwiczenia pilates core',
  media_content_section_multi_1_subheader_text: 'Filmy szkoleniowe',
  media_content_section_multi_2_subheader_text: 'Filmy o jodze',
  media_content_section_multi_3_subheader_text: 'Filmy Pilates',
  text_media_1: 'Mężczyźni',
  text_media_2: 'Kobiety',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Z powrotem',
  page_media_content_menu_chest: 'Klatka piersiowa',
  page_media_content_menu_legs: 'Nogi',
  page_media_content_menu_shoulders: 'Plecy',
  page_media_content_menu_abdominals: 'Mięśnie brzucha',
  components_text1_subheader_text: 'Zdrowa dieta dla Twojego aktywnego życia',
  components_text1_span_text: 'Zdrowe przepisy, które wspomogą Twój trening i poprawią Twoje samopoczucie.',
  components_footer_text: 'Wzmocnij swoje ciało, zrównoważ umysł i ruszaj się sensownie – Twoje miejsce na siłownię, jogę i pilates.',
};